import { render } from "./DeleteSvgIcon.vue?vue&type=template&id=4c1f55dc"
import script from "./DeleteSvgIcon.vue?vue&type=script&lang=js"
export * from "./DeleteSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__